import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { genURL } from './../_getjson';
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'

require('./PopUpCreditCode.css');
export default class PopUpOther extends React.Component {
    state = {
        type: this.props.type,
        col: [],
        rows: [],
        Htext: "",
        SHtype: 3,
    }
    _chkload = status => {
        switch (status) {
            case "Error":
                this.setState({ loadding: "ไม่สามารถโหลดข้อมูลได้" });
                break;
            case "Nodata":
                this.setState({ loadding: "ไม่พบข้อมูล" });
                break;
            case "Loadding":
                this.setState({
                    loadding: (
                        <div align="center">
                            กำลังโหลดข้อมูล
                        </div>
                    )
                });
                break;
        }
    };
    componentDidMount() {

        var url
        var dataArray
        switch (this.props.type) {
            case "Accountcode":
                console.log("Accountcode");
                this.setState({ openBackdrop: true })
                dataArray = [];
                url = "CSGLCHART/GetAll?MFLAG=1";
                console.log(genURL(url));
                axios.get(genURL(url)).then(async res => {
                    for (var i = 0; i < res.data.length; i++) {
                        if (res.data[i].CHILDLEVEL === 0 || res.data[i].CHILDLEVEL === 1 || (res.data[i].CHILDLEVEL === 2 && res.data[i].DRAWBOLD === 1) || (res.data[i].CHILDLEVEL === 3 && res.data[i].USEONTRANS === 1)) {
                            dataArray[i] = await {
                                number: i + 1,
                                code: res.data[i].CODE,
                                text: res.data[i].MYNAMETH,
                                MYNAMEEN: res.data[i].MYNAMEEN,
                                USEONTRANS: res.data[i].USEONTRANS,
                                CHILDLEVEL: res.data[i].CHILDLEVEL,
                                DRAWBOLD: res.data[i].DRAWBOLD,
                            }
                        }
                    }
                    await this.setState({ rows: dataArray, Htext: "ค้นหารหัสบัญชี" });
                    this.setState({ openBackdrop: false })
                })
                    .catch(error => {
                        this._chkload("Error" + error);
                        this.setState({ openBackdrop: false })
                    });
                break;
            default: break;
        }
    }
    onSelectRow = (data) => {
        console.log(data);
        var reData, reDatatxt;
        if (data.text !== "") {
            reDatatxt = data.text
        }
        switch (this.props.type) {
            case "Prefix":
                reData = data.text; break;
            default: reData = data.code; break;
        }
        if (data.USEONTRANS === 1) {
            setTimeout(() => {
                this.props.Get_PopUpOther(reData, reDatatxt);
            }, 1);
        }
    }
    columnClassNameFormat = (fieldValue, row, rowIdx, colIdx) => {
        let nbsp
        if (row.CHILDLEVEL === 0 || row.CHILDLEVEL === 1 || (row.CHILDLEVEL === 2 && row.DRAWBOLD === 1)) {
            nbsp = "nbspall"
        }
        return nbsp
    }
    columnClassNameFormat1 = (fieldValue, row, rowIdx, colIdx) => {
        let nbsp
        if (row.CHILDLEVEL === 0) {
            nbsp = "nbsp"
        }
        if (row.CHILDLEVEL === 1) {
            nbsp = "nbsp0"
        }
        if (row.CHILDLEVEL === 2 && row.DRAWBOLD === 0) {
            nbsp = "nbsp11"
        }
        if (row.CHILDLEVEL === 2 && row.DRAWBOLD === 1) {
            nbsp = "nbsp1"
        }
        if (row.CHILDLEVEL === 3) {
            nbsp = "nbsp2"
        }
        return nbsp
    }
    render() {
        return (
            <div className='popup'  >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-search" > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div class="panel-body divTable" align="right">
                        {this.state.showSH === true ?
                            <div>
                                <div class="input-group group-custom" style={{ width: "30%", marginBottom: "5px" }}>
                                    <input id="id1" type="text" class="form-control input-custom" onChange={this.onSearch} />
                                    <span class="input-group-addon txt-img"><i class="fas fa-search" ></i></span>
                                </div>
                            </div>
                            : null
                        }
                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูลที่ค้นหา",
                            }}
                            height="750"
                            hover condensed search={!this.state.showSH}>
                            <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="20" dataField='number' isKey> </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='code' columnClassName={this.columnClassNameFormat.bind(this)}  > รหัส </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='text' columnClassName={this.columnClassNameFormat1.bind(this)} > ชื่อ/คำอธิบาย </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="170" dataField='MYNAMEEN' > ชื่อบัญชีภาษาอังกฤษ </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="170" rowSpan="2" hidden dataField='USEONTRANS' > </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="170" rowSpan="2" hidden dataField='CHILDLEVEL' > </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="170" rowSpan="2" hidden dataField='DRAWBOLD' > </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}